import { Subject } from 'rxjs';
import { AppConfig } from '../config';

const tokenUpdatedSubject = new Subject<string>();

export class TokenRefreshService {
  static updateToken(newToken: string) {
    localStorage.setItem(AppConfig.tokenKey, newToken);
    tokenUpdatedSubject.next(newToken);
  }

  static onTokenUpdated() {
    return tokenUpdatedSubject.asObservable();
  }
}
